import { HitAllResult } from '@/components/search/types';
import { TableAssetItemProps } from '@/components/table/TableAssetItem';

export function mapAssetHit(hit: HitAllResult): TableAssetItemProps {
  return {
    id: hit.id,
    title: hit.title || '',
    category: [],
    uploaded_on: hit.date_published || '',
    filesize: hit.filesize || '',
    ffbbsite_asset_tag_parent: hit?.ffbbsite_asset_tag_parent || '',
  };
}
